import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-group',
  templateUrl: './te-role-group.component.html',
  styleUrls: ['./te-role-group.component.css']
})
export class TeRoleGroupComponent {

}
